<template>
<!-- 下载中心 -->
    <div>
        <div><el-button type="primary" size="small" @click="addDownload">添加</el-button></div> 
        <div class="downCenter">
            <div class="container">
                <table>
                    <thead class="thead">
                        <tr>
                            <th colspan="3">全部总共：{{count}}</th>
                        </tr>
                        <tr>
                            <th>名称33</th>
                            <th>下载次数</th>
                            <th>更新时间</th>
                            <th class="update" colspan="2">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="infoit in infos" :key="infoit.id">
                            <td>
                                <a class="link_style" target="_blank" :href="infoit.url" >{{infoit.sku}} <span style="color:#000;">—</span> {{infoit.productName}}</a>
                            </td>
                            <td>{{infoit.downTimes}}</td>
                            <td>{{infoit.updateTime}}</td>
                            <td class="update">
                                <el-button size="mini" @click="updataDownload(infoit)">编辑</el-button>&ensp;
                            </td>
                            <td class="delete">
                                <el-popconfirm title="确定要删除吗？" icon="el-icon-info" icon-color="red" @confirm="deleteDownload(infoit.id)">
                                    <el-button size="mini" type="danger" slot="reference">删除</el-button>
                                </el-popconfirm>    
                            </td>
                            <!-- <td>{{infoit.}}</td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="pagination">
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="10"
                    layout="sizes, prev, pager, next"
                    :total="count">
                </el-pagination>
            </div>
        </div>
        <el-dialog :title="title+'下载中心信息'" :visible.sync="dialogFormVisible" class="personalInfo">
            <el-form :model="downloadObj" ref="downloadObj">
                <el-form-item label="下载次数" class="labelWidth" prop="name" v-if="title != '新增'">
                    <el-input v-model="downloadObj.downTimes" :disabled=" title == '修改' ? true:false"></el-input>
                </el-form-item>
                <el-form-item label="商品名称" class="labelWidth">
                    <el-input v-model="downloadObj.productName" ></el-input>
                </el-form-item>
                <el-form-item label="sku" class="labelWidth">
                    <el-input v-model="downloadObj.sku" ></el-input>
                </el-form-item>
                <el-form-item label="url" class="labelWidth">
                    <el-input v-model="downloadObj.url"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitUpdate">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// getListDownloadCenters   查询下载中心信息
// deleteDownloadCenters    删除下载中心信息
// saveDownloadCenters      保存下载中心信息
// updataDownloadCenters    修改下载中心信息
import { 
getListDownloadCenters,
deleteDownloadCenters,
saveDownloadCenters,
updataDownloadCenters} from '@/service'
export default {
    name: 'YinshiOffcialwebsiteDownloadCenter',

    data() {
        return {
            // 分页
            pageObj:{
                page:1,
                pageSize:10,
            },
            // 总条数
            count:0,
            // 下载列表
            infos:[],
            title:'',
            dialogFormVisible:false,
            // 要修改或者要增加
            downloadObj:{
                downTimes:'',
                productName:'',
                sku:'',
                url:'',
                id:'',
            },
        };
    },

    mounted() {
        
    },

    methods: {
        // 每页多少条
        handleSizeChange(val){
            this.pageObj.pageSize = val
            this.selectListDownloadCenters()
        },
        // 页码
        handleCurrentChange(val){
            this.pageObj.page = val
            this.selectListDownloadCenters()
        },
        // 查询下载列表
        async selectListDownloadCenters(){
            let res = await getListDownloadCenters({page:this.pageObj.page,pageSize:this.pageObj.pageSize});
            if(res.code == 200){
                this.infos = res.data
                this.count = res.page.count
            }
        },
        // 删除
        async deleteDownload(id){
            let res = await deleteDownloadCenters(id);
            if(res.code == 200){
                this.$message({ message: '删除成功！', type: 'success' });
                this.selectListDownloadCenters()
            }else{
                this.$message({message: '删除失败！',type: 'error'});
            }
        },
        // 保存下载中心信息
        async saveDownload(){
            
        },
        // 修改下载中心信息
        async updataDownload(obj){
            this.dialogFormVisible = true
            this.downloadObj.downTimes = obj.downTimes
            this.downloadObj.productName = obj.productName
            this.downloadObj.sku = obj.sku
            this.downloadObj.url = obj.url
            this.downloadObj.id = obj.id
            this.title = '修改'
        },
        // 新增
        addDownload(){
            this.dialogFormVisible = true
            this.downloadObj.downTimes = ''
            this.downloadObj.productName = ''
            this.downloadObj.sku = ''
            this.downloadObj.url = ''
            this.downloadObj.id = ''
            this.title = '新增'

        },
        // 提交修改
        async submitUpdate(){
            console.log(123)
            let res;
            if(this.title == '修改'){
                res = await updataDownloadCenters(this.downloadObj);
                
            }else{  //新增
                delete this.downloadObj.id
                res = await saveDownloadCenters(this.downloadObj);
            }
            if(res.code == 200){
                this.$message({ message: this.title+'成功！', type: 'success' });
                this.selectListDownloadCenters()
                this.dialogFormVisible = false
            }else{
                this.$message({message: this.title+''+res.msg+'！',type: 'error'});
            }


        }
    },
    created(){
        this.$store.state.adminCurrentRouter = this.$route.path  //获取当前页面路由
        this.selectListDownloadCenters()
    }
};
</script>

<style lang="scss" scoped>
// 下载中心
.downCenter{
    .container{
        margin-top: 20px;
        margin-bottom: 20px;
        /* margin: 100px;
        padding: 30px;
        transition: all ease 0.5s;
        border: 1px dashed salmon; */
    }

    table{
        font-size: 14px;
        width: 100%;
    }
    table tr{
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        height: 50px;
    }
    table td,table th{
        padding-left: 40px;
        text-align: left;
    }
    .link_style{
        color:#1e73be ;
    }
}
.update{
    width: 50px;
    line-height: 0px;
}
.delete{
    padding-left:10px !important;
    width: 50px;
}
// 分页
.pagination{
    padding: 0px 270px 30px 270px;
    text-align: center;
}
</style>